/**
 * addit Theme — Cart Drawer
 * Slide-in cart with AJAX quantity updates, section rendering API refresh,
 * and a public window.CartDrawer API for integration with product.js
 */
(function () {
  'use strict';

  var drawer  = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-cart-overlay]');

  /* ==========================================================================
     Open / Close  (null-safe — work even if drawer hasn't rendered)
     ========================================================================== */
  function open() {
    if (!drawer || !overlay) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.classList.add('is-visible');
    document.body.classList.add('drawer-open');
    var closeBtn = drawer.querySelector('[data-cart-close]');
    if (closeBtn) closeBtn.focus();
  }

  function close() {
    if (!drawer || !overlay) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('is-visible');
    document.body.classList.remove('drawer-open');
  }

  /* ==========================================================================
     Counts — the drawer badge is the logical count computed in Liquid
     (all lines of one _bundle_id count once, so a Starter Set is 1)
     ========================================================================== */
  function syncHeaderCount(n) {
    /* querySelectorAll: a page can carry both header paths (header.liquid, launch-cart-link) */
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('is-hidden', n === 0);
    });
  }

  /* ==========================================================================
     Section Rendering API — swaps [data-cart-drawer-content] with fresh HTML
     ========================================================================== */
  function refresh(callback) {
    if (!drawer) { if (callback) callback(); return; }
    fetch('/?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data['cart-drawer']) { if (callback) callback(); return; }

        var parser     = new DOMParser();
        var doc        = parser.parseFromString(data['cart-drawer'], 'text/html');
        var newContent = doc.querySelector('[data-cart-drawer-content]');
        var curContent = drawer.querySelector('[data-cart-drawer-content]');
        if (newContent && curContent) curContent.innerHTML = newContent.innerHTML;

        /* Re-fill the delivery-promise line — innerHTML swaps don't run scripts */
        if (window.DeliveryPromise && window.DeliveryPromise.init) window.DeliveryPromise.init();

        // Sync drawer count badge
        var newBadge = doc.querySelector('[data-drawer-count-badge]');
        var curBadge = drawer.querySelector('[data-drawer-count-badge]');
        if (newBadge && curBadge) {
          curBadge.textContent = newBadge.textContent;
          curBadge.classList.toggle('is-hidden', newBadge.classList.contains('is-hidden'));
        }

        // Sync header cart count (logical count, same as the drawer badge)
        if (newBadge) syncHeaderCount(parseInt(newBadge.textContent, 10) || 0);

        if (callback) callback();
      })
      .catch(function () { if (callback) callback(); });
  }

  /* ==========================================================================
     Cart changes — every change re-renders the drawer from Liquid instead of
     patching prices in place. The in-place patch printed '98,00 €' next to
     Liquid's '€59,00', left the cross-sell out after the pouch was removed and
     wrote the raw item_count into both badges (cc-12, cc-05).
     ========================================================================== */
  var busy = false;

  function contentEl() {
    return drawer ? drawer.querySelector('[data-cart-drawer-content]') : null;
  }

  /* Controls stay disabled while a request runs: a second tap before the re-render would post
     against stale line numbers. Only controls we disable here are re-enabled, so the capped
     Set '+' keeps its disabled state. */
  function lock() {
    busy = true;
    var content = contentEl();
    if (!content) return;
    content.classList.add('is-refreshing');
    content.setAttribute('aria-busy', 'true');
    content.querySelectorAll('button:not([disabled]), input:not([disabled])').forEach(function (el) {
      el.disabled = true;
      el.setAttribute('data-busy-disabled', '');
    });
  }

  function unlock() {
    busy = false;
    var content = contentEl();
    if (!content) return;
    content.classList.remove('is-refreshing');
    content.removeAttribute('aria-busy');
    content.querySelectorAll('[data-busy-disabled]').forEach(function (el) {
      el.disabled = false;
      el.removeAttribute('data-busy-disabled');
    });
  }

  /* The re-render replaces the focused control, so keyboard focus fell to <body>, outside the
     aria-modal dialog (cc-12 follow-up). Remember the control by stable attributes (the line item
     key, not the line number, which shifts after a removal) and focus its fresh copy.
     null = focus was not in the drawer, '' = nothing stable to match. */
  function focusedControl() {
    var el = document.activeElement;
    var content = contentEl();
    if (!el || !content || !content.contains(el)) return null;
    var item = el.closest('[data-cart-item]');
    var scope = item ? '[data-cart-item][data-key="' + CSS.escape(item.getAttribute('data-key') || '') + '"] ' : '';
    if (el.hasAttribute('data-qty-btn')) return scope + '[data-qty-btn][data-delta="' + el.getAttribute('data-delta') + '"]';
    if (el.hasAttribute('data-remove-line')) return scope + '[data-remove-line]';
    if (item && el.tagName === 'INPUT') return scope + 'input';
    if (el.hasAttribute('data-bundle-qty-btn')) {
      return '[data-bundle-qty-btn][data-bundle-id="' + CSS.escape(el.getAttribute('data-bundle-id') || '') + '"][data-delta="' + el.getAttribute('data-delta') + '"]';
    }
    return '';
  }

  function restoreFocus(selector) {
    if (selector === null || !drawer || !drawer.classList.contains('is-open')) return;
    var content = contentEl();
    var target = selector && content ? content.querySelector(selector) : null;
    /* A Set '+' that reached its cap comes back disabled: move to the enabled stepper button */
    if (target && target.disabled) target = target.parentNode.querySelector('button:not([disabled])');
    /* The control is gone (line removed, cross-sell added): stay inside the dialog */
    if (!target) target = drawer.querySelector('[data-cart-close]');
    if (target) target.focus({ preventScroll: true });
  }

  /* request() returns a fetch promise (or undefined when nothing needs to change) */
  function mutate(request) {
    if (busy) return;
    var focusSelector = focusedControl(); /* before lock(): disabling the control blurs it */
    lock();
    Promise.resolve()
      .then(request)
      .then(function (r) {
        if (r && !r.ok) {
          return r.json().then(function (err) { return err && err.description; }, function () {})
            .then(function (text) { showNotice(text || 'Die Menge konnte nicht geändert werden. Bitte versuch es noch einmal.'); });
        }
      })
      .catch(function () {})
      .then(function () {
        refresh(function () { unlock(); restoreFocus(focusSelector); });
      });
  }

  function cartChange(line, qty) {
    mutate(function () {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ line: line, quantity: qty })
      });
    });
  }

  /* ==========================================================================
     Event listeners — ALL set up unconditionally (no early return above)
     ========================================================================== */

  // 1. Cart icon → open drawer (prevent navigation to /cart page)
  //    On the /cart page itself, let the link navigate normally.
  document.addEventListener('click', function (e) {
    var cartLink = e.target.closest('[data-cart-link]');
    if (!cartLink) return;
    if (document.body.classList.contains('template-cart')) return;
    if (!drawer) return; // drawer didn't render — fallback to normal navigation
    e.preventDefault();
    open();
  });

  // 2. Close button or overlay
  document.addEventListener('click', function (e) {
    if (!drawer || !overlay) return;
    if (e.target.closest('[data-cart-close]') || e.target === overlay) close();
  });

  // 3. ESC key
  document.addEventListener('keydown', function (e) {
    if (!drawer) return;
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });

  // 4. Quantity +/- (scoped to drawer)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-btn]');
    if (!btn || !drawer || !drawer.contains(btn) || btn.disabled) return;
    var itemEl = btn.closest('[data-cart-item]');
    if (!itemEl) return;
    var line   = parseInt(itemEl.getAttribute('data-line'), 10);
    var input  = itemEl.querySelector('input');
    var delta  = parseInt(btn.getAttribute('data-delta'), 10);
    var newQty = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
    input.value = newQty;
    cartChange(line, newQty);
  });

  // 4b. Typed quantity (scoped to drawer)
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!drawer || !drawer.contains(input) || input.tagName !== 'INPUT') return;
    var itemEl = input.closest('[data-cart-item]');
    if (!itemEl) return;
    cartChange(parseInt(itemEl.getAttribute('data-line'), 10), Math.max(0, parseInt(input.value, 10) || 0));
  });

  // 5. Remove button (scoped to drawer)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-remove-line]');
    if (!btn || !drawer || !drawer.contains(btn)) return;
    e.preventDefault();
    cartChange(parseInt(btn.getAttribute('data-remove-line'), 10), 0);
  });

  // 5b. Cross-sell: one-click add (extra pouch) — delegated, survives refreshes
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cross-sell-add]');
    if (!btn || busy) return;
    e.preventDefault();
    var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (!variantId) return;
    btn.textContent = '…';
    mutate(function () {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
    });
  });

  // 6. Bundle quantity +/- (changes all components proportionally)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bundle-qty-btn]');
    if (!btn || !drawer || !drawer.contains(btn)) return;
    e.preventDefault();
    if (btn.disabled) return;

    var bundleId = btn.getAttribute('data-bundle-id');
    /* .cart-bundle, not [data-bundle-id]: the button carries data-bundle-id itself, so closest()
       returned the button and data-bundle-max parsed as NaN — the cap never applied (cc-11) */
    var bundleEl = btn.closest('.cart-bundle');
    var delta = parseInt(btn.getAttribute('data-delta'), 10);

    mutate(function () {
      /* Always read current state from cart API (single source of truth) */
      return fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var components = cart.items.filter(function (item) {
            return item.properties && item.properties['_bundle_id'] === bundleId;
          });
          if (!components.length) return;

          /* Components scale together, so the first component's quantity is the set count
             (each component is added once per set) */
          var setCount = components[0].quantity;
          var newSetCount = Math.max(0, setCount + delta);
          /* Respect a per-order cap (data-bundle-max on the bundle element; 0 = uncapped) */
          var maxSet = bundleEl ? parseInt(bundleEl.getAttribute('data-bundle-max'), 10) || 0 : 0;
          if (maxSet > 0 && newSetCount > maxSet) newSetCount = maxSet;
          if (newSetCount === setCount) return;

          var updates = {};
          components.forEach(function (item) {
            var perSet = Math.round(item.quantity / setCount);
            updates[item.key] = perSet * newSetCount;
          });

          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: updates })
          });
        });
    });
  });

  /* The header snippets print the raw cart.item_count (a Starter Set is 2 lines) — align them
     with the drawer's logical count on load, so a reload doesn't turn '1' into '2' (cc-12) */
  if (drawer) {
    var loadBadge = drawer.querySelector('[data-drawer-count-badge]');
    if (loadBadge) syncHeaderCount(parseInt(loadBadge.textContent, 10) || 0);
  }

  /* ==========================================================================
     Public API — called by product.js after add-to-cart
     ========================================================================== */
  var noticeTimer = null;
  function showNotice(message) {
    if (!drawer) return;
    var el = drawer.querySelector('[data-cart-notice]');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
    void el.offsetWidth; /* reflow so the fade/slide transition plays */
    el.classList.add('is-visible');
    clearTimeout(noticeTimer);
    noticeTimer = setTimeout(function () {
      el.classList.remove('is-visible');
      setTimeout(function () { if (!el.classList.contains('is-visible')) el.hidden = true; }, 300);
    }, 6000);
  }

  window.CartDrawer = {
    open: function (shouldRefresh) {
      open();
      if (shouldRefresh && drawer) {
        var content = contentEl();
        if (content) content.classList.add('is-refreshing');
        refresh(function () {
          if (content) content.classList.remove('is-refreshing');
        });
      }
    },
    close: close,
    refresh: refresh,
    notify: showNotice
  };
})();
